<nav  class="navbar main-navbar on-top" [class.nav-shadow]='this.pageYPosition>0'>
  <div class="status-bar" [dir]="'Direction' | translate">
    <div class="status-content">
      <div class="button-style border border-secondary rounded">
      
        <img src="assets/icons/calendar.png" alt="Date and Time" width="16" height="16" />
        <span class="datetime">{{ formattedDate }}</span>
      </div>
      <div class="button-style border border-secondary rounded">
        <span class="datetime">{{marketStatus()}}<i></i></span>
      </div>
     
  
      <div class="row-2">
        <!-- Trade Now Dropdown with Icon -->
        <div ngbDropdown class="d-inline-block"
             (mouseover)="openDropdown()"
             (mouseout)="closeDropdown()"
             [class.show]="showDropdown">
          <button class="dropdown-toggle border border-secondary rounded button-style trade-button" (click)="navigateTo('newETrade')">
            <img src="assets/icons/line-chart.png" alt="Trade" width="16" height="16" />  {{"Trade Now" | translate}}
          </button>
          <!-- <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button class="dropdown-item" (click)="navigateTo('eTrade')">
              <img src="assets/icons/line-chart.png" alt="eTrade" width="16" height="16" />  {{"eTrade" | translate}}
            </button>
            <button class="dropdown-item" (click)="navigateTo('newETrade')">
              <img src="assets/icons/line-chart.png" alt="eTrade" width="16" height="16" />  {{"newETrade" | translate}}
            </button>
             <button class="dropdown-item" (click)="navigateTo('ultimateTrade')">
              <img src="assets/icons/line-chart.png" alt="Ultimate Trade" width="16" height="16" /> {{"Ultimate Trade" | translate}}
            </button>
            
           
          </div> -->
        </div>
  
        <!-- Open Account Button with Icon -->
        <button class="open-account-button border border-secondary rounded button-style" (click)="navigateToContactUsWithOpenAccount()">
          <img src="assets/icons/add-user.png" alt="Open Account" width="16" height="16" />
          {{"openAccount" | translate}}
        </button>
        <button *ngIf="languageFormControl.value === 'en'" class="open-account-button border border-secondary rounded button-style language-con" (click)="changeLanguage('ar')">
          <img src="assets/icons/worldwide.png" alt="العربية" width="16" height="16" />  العربية 
        </button>
        <button *ngIf="languageFormControl.value === 'ar'" class="open-account-button border border-secondary rounded button-style language-con"  (click)="changeLanguage('en')">
          <img src="assets/icons/worldwide.png" alt="English" width="16" height="16" style="margin-left: 5px;"/>English
        </button>
        
      </div>
  
      <div class="row-3 ">
        <!-- Search Container with Icon -->
        <div class="search-container  ignore-mb">
          <input type="text" placeholder="{{ 'search' | translate }}..." [formControl]="searchControl">
          <button class="search-icon-button" (click)="search()">
            <img src="assets/icons/search.svg" alt="Search" />
          </button>
          <div class="search-results" *ngIf="filteredStocks.length > 0">
            <ul>
              <li *ngFor="let stock of filteredStocks.slice(0, 10)" (click)="onSelectStock(stock.isin)">
                {{ stock.englishName }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  


    <div [@animateMenu] class="mid-container" [dir]="'Direction' | translate">
        <a class="navbar-brand text-light" [routerLink]="'home'">
            <img src='assets/images/pioLogo.png' width='25' />
        </a>
        <div class="nav-center-wrapper">
            <ul ngbNav #nav="ngbNav" class="menu-ul">
                <li ngbNavItem (click)="analyticsService.sendAnalyticEvent('click_about', 'menu', 'click')">
                  <a ngbNavLink [routerLink]="'/home'"><span class='nav-number'></span> <span class="underline nav-text">{{"Header.Item1" | translate}}</span></a>
                  <ng-template ngbNavContent>First content</ng-template>
                </li>
                <li ngbNavItem (click)="analyticsService.sendAnalyticEvent('click_about', 'menu', 'click')">
                  <a ngbNavLink [routerLink]="'/about'"><span class='nav-number'></span> <span class="underline nav-text">{{"Header.Item11" | translate}}</span></a>
                  <ng-template ngbNavContent>First content</ng-template>
                </li>
                <li ngbNavItem (click)="analyticsService.sendAnalyticEvent('click_about', 'menu', 'click')">
                  <a ngbNavLink [routerLink]="'/videos'"><span class='nav-number'></span> <span class="underline nav-text">{{"Header.Item12" | translate}}</span></a>
                  <ng-template ngbNavContent>First content</ng-template>
                </li>
                <!-- <li ngbNavItem (click)="analyticsService.sendAnalyticEvent('click_experience', 'menu', 'click')">
                  <a ngbNavLink [routerLink]="'/reports'"><span class='nav-number'></span> <span class="underline nav-text">{{"Header.Item4" | translate}}</span></a>
                  <ng-template ngbNavContent>Second content</ng-template>
                </li> -->
                <li ngbNavItem class="underline  nav-item dropdown" 
                    (mouseover)="openMainDropdown()" 
                    (mouseout)="closeMainDropdownWithDelay()"
                    [class.show]="isDropdownOpen">
                  <a class="nav-link dropdown-toggle nav-text" id="navbarDropdown" role="button">
                    {{"Header.Item4" | translate}}
                  </a>
                 
                  <div class="dropdown-menu" [ngClass]="{'dropdown-menu': true, 'dropdown-menu-end': languageFormControl.value === 'ar'}" aria-labelledby="navbarDropdown">
                   
                    <a class="dropdown-item" [routerLink]="'/reports'">{{"Header.Item4" | translate}}</a>
                    
                    <a class="dropdown-item" [routerLink]="'/agenda'">{{"Header.Item7" | translate}}</a>
                    <a class="dropdown-item" [routerLink]="'/stocks-information'">{{"Header.Item8" | translate}}</a>
                  </div>
                </li>
                <li ngbNavItem (click)="analyticsService.sendAnalyticEvent('click_about', 'menu', 'click')">
                  <a ngbNavLink [routerLink]="'/news'"><span class='nav-number'></span> <span class="underline nav-text">{{"Header.Item3" | translate}}</span></a>
                  <ng-template ngbNavContent>First content</ng-template>
                </li>
                
                <li ngbNavItem (click)="analyticsService.sendAnalyticEvent('click_experience', 'menu', 'click')">
                  <a ngbNavLink [routerLink]="'/trading-rules'"><span class='nav-number'></span> <span class="underline nav-text">{{"Header.Item10" | translate}}</span></a>
                  <ng-template ngbNavContent>Second content</ng-template>
                </li>
                <li ngbNavItem class="underline  nav-item dropdown" 
                  (mouseover)="openMainDropdown()" 
                  (mouseout)="closeMainDropdownWithDelay()"
                  [class.show]="isDropdownOpen">
                  <a class="nav-link dropdown-toggle nav-text" id="navbarDropdown" role="button">
                    {{"Header.Item5" | translate}}
                  </a>
                
                  <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" [routerLink]="'/market-statistics'">{{"MarketStatus.Title" | translate}}</a>
                    <a class="dropdown-item" [routerLink]="'/market-watch'">{{"Header.Item2" | translate}}</a>
               
                  </div>
                </li>
              
                <li ngbNavItem (click)="analyticsService.sendAnalyticEvent('click_contact', 'menu', 'click')">
                  <a ngbNavLink [routerLink]="'/contact-us'"><span class='nav-number'></span> <span class="underline nav-text">{{"Header.Item6" | translate}}</span></a>
                  <ng-template ngbNavContent>Second content</ng-template>
                </li>
              </ul>
        </div>
        <div class="language-icon">
            <!-- <img
              *ngIf="languageFormControl.value === 'en'"
              src="https://www.worldometers.info/img/flags/eg-flag.gif"
              alt="Arabic"
              (click)="changeLanguage('ar')"
              width="20px"
            />
            <img
              *ngIf="languageFormControl.value === 'ar'"
              src="https://www.worldometers.info/img/flags/us-flag.gif"
              alt="English"
              (click)="changeLanguage('en')"
              width="20px"
            /> -->
          </div>
          <div class="menu-wrapper">
            <div [class.animate]='responsiveMenuVisible' (click)='responsiveMenuVisible = !responsiveMenuVisible' class="hamburger-menu"></div>
        </div>
        <div class="menu-responsive" [ngStyle]="{'pointer-events': !responsiveMenuVisible ? 'none' : '' }">
            <aside [class.aside-show]='responsiveMenuVisible' [class.nav-shadow]='this.pageYPosition>0' class="on-top">
                <nav>
                    <ol>
                      <li>
                        <div class="search-container">

                          <input type="text" placeholder="{{ 'search' | translate }}..." [formControl]="searchControl">
                          <button class="search-icon-button ignore-mb" (click)="search()">
                            <img src="assets/icons/search.svg" alt="Search" />
                          </button>
                          <div class="search-results" *ngIf="filteredStocks.length > 0">
                            <ul>
                              <li *ngFor="let stock of filteredStocks.slice(0, 10)" (click)="onSelectStock(stock.isin)">
                                {{ stock.englishName }}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                        <li (click)='analyticsService.sendAnalyticEvent("click_about", "menu", "click"); closeMenu();'>
                            <a [routerLink]="'/home'">
                                <span></span> {{"Header.Item1" | translate}}
                            </a>
                        </li>
                        <li (click)='analyticsService.sendAnalyticEvent("click_about", "menu", "click"); closeMenu();'>
                          <a [routerLink]="'/about'">
                              <span></span> {{"Header.Item11" | translate}}
                          </a>
                      </li>
                        <li (click)='analyticsService.sendAnalyticEvent("click_experience", "menu", "click"); closeMenu();'>
                            <a [routerLink]="'/market-statistics'">
                                <span></span> {{"Header.Item5" | translate}}
                            </a>
                        </li>
                        <li (click)='analyticsService.sendAnalyticEvent("click_jobs", "menu", "click");closeMenu();'>
                            <a [routerLink]="'/news'">
                                <span></span> {{"Header.Item3" | translate}}
                            </a>
                        </li>
                        <li (click)='analyticsService.sendAnalyticEvent("click_jobs", "menu", "click");closeMenu();'>
                            <a [routerLink]="'/market-watch'">
                                <span></span> {{"Header.Item2" | translate}}
                            </a>
                        </li>
                        <li (click)='analyticsService.sendAnalyticEvent("click_contact", "menu", "click");closeMenu();'>
                            <a [routerLink]="'/reports'">
                                <span></span> {{"Header.Item4" | translate}}
                            </a>
                        </li>
                        <li (click)='analyticsService.sendAnalyticEvent("click_contact", "menu", "click");closeMenu();'>
                          <a [routerLink]="'/videos'">
                              <span></span> {{"Header.Item12" | translate}}
                          </a>
                      </li>
                        <li (click)='analyticsService.sendAnalyticEvent("click_contact", "menu", "click");closeMenu();'>
                            <a [routerLink]="'/stocks-information'">
                                <span></span> {{"Header.Item8" | translate}}
                            </a>
                        </li>
                        <li (click)='analyticsService.sendAnalyticEvent("click_contact", "menu", "click");closeMenu();'>
                            <a [routerLink]="'/agenda'">
                                <span></span> {{"Header.Item7" | translate}}
                            </a>
                        </li>
                        
                        <li (click)='analyticsService.sendAnalyticEvent("click_contact", "menu", "click");closeMenu();'>
                            <a [routerLink]="'/contact-us'">
                                <span></span> {{"Header.Item6" | translate}}
                            </a>
                        </li>
                        
                        <li>
                            <div class="language-container">
                                <div (click)='changeLanguage("ar")' class="language-container language-container-selector active" [class.active]='languageFormControl.value == "ar"'>
                                    <img src="https://www.worldometers.info/img/flags/eg-flag.gif" alt="Arabic">
                                    <span class="flag-text" style="direction: rtl;">العربية</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2 arrow-active" viewBox="0 0 16 16">
                                        <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                                    </svg>
                                </div>
                                <div (click)='changeLanguage("en")' class="language-container language-container-selector" [class.active]='languageFormControl.value == "en"'>
                                    <img src="https://www.worldometers.info/img/flags/us-flag.gif" alt="English">
                                    <span class="flag-text">English</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2 arrow-active" viewBox="0 0 16 16">
                                        <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                                    </svg>
                                </div>
                            </div>
                        </li>
                    </ol>
                </nav>
            </aside>
        </div>
    </div>

    <div class="news-ticker">
        <marquee [attr.direction]="languageFormControl.value === 'ar' ? 'right' : 'left'">
            <ng-container *ngIf="stockNews.length > 0; else noNews">
                <span *ngFor="let stock of stockNews">
                    <span class="stock-name" >{{ stock.englishName }}</span>
                    <span style="color: rgb(20, 20, 20);">
                        {{ stock.open }}
                    </span>
                    <span class="close-price" [ngStyle]="{'color': stock.change > 0 ? 'green' : stock.change == 0 ? 'rgb(20, 20, 20)' : 'red'}">
                        {{ stock.close }}
                    </span>
                    <span [ngStyle]="{'color': stock.change > 0 ? 'green' : stock.change == 0 ? 'rgb(20, 20, 20)' : 'red'}">
                        {{ stock.change }}%
                    </span> &nbsp;
                </span>
            </ng-container>
            <ng-template #noNews>No news available</ng-template>
        </marquee>
    </div>
</nav>
